import { render, staticRenderFns } from "./visits.vue?vue&type=template&id=a42af28e&scoped=true"
import script from "./visits.vue?vue&type=script&lang=js"
export * from "./visits.vue?vue&type=script&lang=js"
import style0 from "./visits.vue?vue&type=style&index=0&id=a42af28e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42af28e",
  null
  
)

export default component.exports